import * as React from "react";
import {
  Box,
  Typography,
  Stack,
  Paper,
  Button,
} from "@mui/material";
import { useI18n } from "../../i18n/I18nProvider";

const SHARE_PHOTO_RESUME_INDEX_KEY = "tk.sharePhotoResumeIndex";
const SHARE_PHOTO_DONE_KEY = "tk.sharePhotoDone";

export default function TakeAPhoto(props: { handlePageChange: (page: string) => void }) {
  const { handlePageChange } = props;
  const { lang } = useI18n();
  const isDE = lang === "de";

  /* ---------------- NAVIGATION ---------------- */

  function handleContinue() {
    sessionStorage.setItem(SHARE_PHOTO_DONE_KEY, "1");
    handlePageChange("VibeQuestions:share");
  }

  function handleBack() {
    const resumeIndex = Number(sessionStorage.getItem(SHARE_PHOTO_RESUME_INDEX_KEY));
    const previousIndex = Number.isInteger(resumeIndex) ? Math.max(0, resumeIndex - 1) : 0;

    sessionStorage.setItem(SHARE_PHOTO_RESUME_INDEX_KEY, String(previousIndex));
    sessionStorage.removeItem(SHARE_PHOTO_DONE_KEY);
    handlePageChange("VibeQuestions:share");
  }

  /* ---------------- UI ---------------- */

  return (
    <Box
      sx={{
        minHeight: "100vh",
        px: { xs: 2, sm: 3 },
        py: { xs: 3, sm: 6 },
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: `
          radial-gradient(circle at 20% 20%, rgba(251, 2, 2, 0.08), transparent 40%),
          radial-gradient(circle at 80% 30%, rgba(255, 0, 0, 0.06), transparent 40%),
          #111010
        `,
        backgroundImage: `
          linear-gradient(
            rgba(8, 8, 8, 0.78),
            rgba(8, 8, 8, 0.82)
          ),
          url("/scenarioBgs/selfie.png")
        `,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundAttachment: "fixed",
      }}
    >
      <Paper
        sx={{
          width: "min(900px, 90vw)",
          borderRadius: 5,
          p: { xs: 4, sm: 6, md: 7 },

          border: "1px solid rgba(255,255,255,0.14)",
          background:
            "linear-gradient(180deg, rgba(49, 32, 32, 0.95), rgba(34, 21, 21, 0.94))",

          boxShadow: "0 24px 65px rgba(0,0,0,0.45)",
          textAlign: "center",
        }}
      >
        <Stack spacing={5} alignItems="center">

          {/* TITLE */}
          <Typography
            sx={{
              color: "#fff",
              fontSize: { xs: "1.5rem", sm: "2rem" },
              fontWeight: 800,
              letterSpacing: "0.06em",
              lineHeight: 1.3,
            }}
          >
            {isDE
              ? "STÄRKE beginnt mit KLARHEIT"
              : "STRENGTH begins with CLARITY"}
          </Typography>

          {/* MAIN TEXT */}
          <Typography
            sx={{
              color: "#fff",
              fontSize: { xs: "1.05rem", sm: "1.2rem" },
              fontWeight: 600,
              maxWidth: 720,
              lineHeight: 1.6,
            }}
          >
            {isDE
              ? "Deine letzte Aufgabe:"
              : "Your final task:"}
          </Typography>

          {/* DESCRIPTION */}
          <Typography
            sx={{
              color: "rgba(255,255,255,0.75)",
              fontSize: { xs: "0.95rem", sm: "1.1rem" },
              maxWidth: 720,
              lineHeight: 1.7,
            }}
          >
            {isDE
              ? "Mache ein Foto vor der Glaswand und teile es auf Social Media. Der erste Schritt ist das Bewusstsein und die bewusste Auseinandersetzung - sie bildet die Grundlage für deine individuelle Vorbereitung."
              : "Take a photo in front of the glass wall and share it on social media. The first step is awareness and conscious engagement - this is the foundation for your individual preparedness."}
          </Typography>

            <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
              <Button
                variant="outlined"
                onClick={handleBack}
                sx={{
                  mt: 1,
                  borderRadius: 999,
                  textTransform: "none",
                  fontWeight: 800,
                  px: 3,
                  borderColor: "rgba(255,255,255,0.4)",
                  color: "#fff",
                  "&:hover": {
                    borderColor: "#fff",
                    backgroundColor: "rgba(255,255,255,0.08)",
                  },
                }}
              >
                {isDE ? "Zurück" : "Back"}
              </Button>

              <Button
                variant="contained"
                onClick={handleContinue}
                sx={{
                  mt: 1,
                  borderRadius: 999,
                  textTransform: "none",
                  fontWeight: 800,
                  px: 3,
                  bgcolor: "#ffffff",
                  color: "#111827",
                  "&:hover": {
                    bgcolor: "#f3f4f6",
                  },
                }}
              >
                {isDE ? "Weiter" : "Continue"}
              </Button>
            </Stack>
        </Stack>
      </Paper>
    </Box>
  );
}
